import React, { useRef, useState, useEffect, useCallback } from "react";
import "./LProgressBar.css";

function clamp(v, a = 0, b = 1) {
  return Math.max(a, Math.min(b, v));
}

export default function LProgressBar({ progressPercent, onSeek, seekable = true }) {
  const [isDragging, setIsDragging] = useState(false);
  const [previewPercent, setPreviewPercent] = useState(null);
  const barRef = useRef(null);

  const getPercentFromEvent = (e) => {
    const rect = barRef.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const x = clientX - rect.left;
    return clamp(x / rect.width, 0, 1);
  };

  const handleStart = (e) => {
    if (!seekable) return;
    e.preventDefault();
    setIsDragging(true);
    const percent = getPercentFromEvent(e);
    setPreviewPercent(percent);
  };

  const handleMove = useCallback(
    (e) => {
      if (!isDragging || !seekable) return;
      const percent = getPercentFromEvent(e);
      setPreviewPercent(percent);
    },
    [isDragging, seekable]
  );

  const handleEnd = useCallback(
    (e) => {
      if (!isDragging || !seekable) return;

      let percent;
      if (e.type.startsWith("touch")) {
        percent = previewPercent !== null ? previewPercent : 0;
      } else {
        percent = getPercentFromEvent(e);
      }

      setIsDragging(false);
      setPreviewPercent(null);
      onSeek?.(percent);
    },
    [isDragging, seekable, onSeek, previewPercent]
  );

  useEffect(() => {
    if (!seekable) return;

    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleEnd);
    document.addEventListener("touchmove", handleMove);
    document.addEventListener("touchend", handleEnd);

    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("touchend", handleEnd);
    };
  }, [handleMove, handleEnd, seekable]);

  const effectivePercent = isDragging ? previewPercent : progressPercent;
  const dotPercent = effectivePercent < 0.05 ? effectivePercent + 0.01 : effectivePercent

  return (
    <div
      ref={barRef}
      className={`l-progress-bar ${seekable ? "" : "read-only"}`}
      onPointerDown={handleStart} 
    >
      <div
        className="l-progress-filled"
        style={{ width: `${effectivePercent * 100}%` }}
      />
      <div
        className="l-progress-dot"
        style={{ left: `calc(${dotPercent * 100}% - 3px)` }}
      />
    </div>
  );
}
